const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/DashboardPage/Sidebar/Sidebar.tsx';
import Imm from 'immutable';
import { theme } from 'App/utils/clientSetupManager';
import { Card, CardActionArea, CardContent, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { useTheme } from '@mui/material/styles';
import { css } from '@emotion/css';
import { MessageDescriptor, useIntl } from 'react-intl';
import textMap from './translations';
import { GapSm } from 'App/components/Gap/Gap';
import { selLocale } from '@cistec/common_web/selectors/i18nSelectors';
import { useSelector } from 'react-redux';
import { IconTextTuples } from '../IconTextTuples';
import { isEmpty } from '@cistec/common_web/utils/generalUtils';
import { useExternalLinks } from 'App/store/externalLink';
import { CSSProperties, useMemo } from 'react';

const styleIcon: CSSProperties = {
    color: theme.palette.primary.main,
    fontSize: theme.spacing(4),
    marginRight: theme.spacing(1.5),
    marginLeft: theme.spacing(-1),
};

const styleText: CSSProperties = {
    color: theme.palette.primary.main,
};

const cardStyle = css`
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
`;

const titleStyle = css`
    background: #e0e0e0;
    width: 100%;
    padding: 10px 8px;
`;
const titleTextStyle = css`
    padding-left: 5px;
`;

const titleContentStyle = css`
    display: flex;
    align-items: center;
    padding: 5px;
    font-size: 1.5rem;
`;

function useCSSClasses() {
    const theme = useTheme();
    return useMemo(
        () => ({
            root: css`
                margin-left: ${theme.spacing(0.5)};
                margin-right: ${theme.spacing(0.5)};
                padding: 4px 16px;
            `,
        }),
        [theme]
    );
}

const linkFrameFlexInline: CSSProperties = { flex: ' 1 1 auto', maxHeight: theme.spacing(8) };

export const Sidebar = () => {
    const cardContentClasses = useCSSClasses();
    const { data: externalLinks } = useExternalLinks();
    const locale = useSelector(selLocale);

    const filteredExternalLinks = useMemo(() => {
        return externalLinks && externalLinks.filter((link: Imm.Map<string, any>) => !!link.get('canSeeOnDashboard'));
    }, [externalLinks]);

    const hasExtLinks = !isEmpty(filteredExternalLinks);

    const { formatMessage } = useIntl();

    const resolveMessage = (message: MessageDescriptor | string) => {
        if (typeof message === 'object') {
            return formatMessage(message);
        }
        return message;
    };

    return hasExtLinks ? (
        <Grid size={{ xs: 12 }}>
            <Card className={cardStyle}>
                <>
                    <div className={titleStyle}>
                        <Typography component="div" sx={{ color: 'common.black' }} className={titleContentStyle}>
                            <span className={titleTextStyle}>{formatMessage(textMap.informationTitle)}</span>
                        </Typography>
                    </div>
                    {filteredExternalLinks.map((link: Imm.Map<string, any>, idx: number) => {
                        return (
                            <CardActionArea
                                key={idx}
                                href={link.get('url')}
                                target="_blank"
                                style={linkFrameFlexInline}
                            >
                                <CardContent classes={cardContentClasses}>
                                    <IconTextTuples
                                        tuples={[
                                            {
                                                icon: 'icons8-' + link.get('icon'),
                                                primaryText: resolveMessage(link.get(locale) || link.get('de')),
                                            },
                                        ]}
                                        styleIcon={styleIcon}
                                        styleText={styleText}
                                    />
                                </CardContent>
                            </CardActionArea>
                        );
                    })}
                    <GapSm />
                </>
            </Card>
        </Grid>
    ) : null;
};
